import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import HealthReport from '@/views/HealthReport.vue'
import PdfTest from "@/views/PdfTest.vue"
import YkbReport from "@/views/YkbReport.vue"
import NewReport from "@/views/NewReport"
import NewReportFullView from "@/views/NewReportFullView"
import Physical from "@/views/Physical/index.vue"
import GuReport from "@/views/GuReport"
import ReportList from "@/views/ReportList"
import HeartBrainReport from "@/views/HeartBrainReport"
import Thyroid from "@/views/thyroid/Index"
import ThyroidDetail from "@/views/thyroid/Details"
import RiskReport from "@/views/risk/RiskReport"
import DiaeaseReport from "@/views/DiaeaseReport/Index"
import keynote from "@/views/IntestinalMotility/keynote" 
import nutrition from "@/views/IntestinalMotility/nutrition" 
import contrast from "@/views/IntestinalMotility/contrast"
import noteDetail from "@/views/IntestinalMotility/noteDetail"
import reportComparison from "@/views/IntestinalMotility/reportComparison"
import PeaceMind from "@/views/PeaceMind"
import PeaceMindH5 from "@/views/PeaceMindH5"
import condition from "@/views/PeaceMindH5/condition"
import system from "@/views/PeaceMindH5/system"
import systemContent from "@/views/PeaceMindH5/systemContent"
import PeaceMindH5Old from "@/views/PeaceMindH5Old"
import conditionOld from "@/views/PeaceMindH5Old/condition"
import systemOld from "@/views/PeaceMindH5Old/system"
import systemContentOld from "@/views/PeaceMindH5Old/systemContent"
import SportsRiskReport from "@/views/SportsRiskReport"
import FullBodyIntelligence from "@/views/FullBodyIntelligence"
import WholeBodyTriage from "@/views/WholeBodyTriage"
import YouthSportsLntelligence from "@/views/YouthSportsLntelligence"


Vue.use(VueRouter)

  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/ReportList',
    name: 'ReportList',
    meta: {
      title: '身体免疫力检测'
      },
    component: ReportList
  },
  {
    path: '/',
    name: 'HealthReport',
    component: HealthReport
  },
  {
    path: '/report',
    name: 'YkbReport',
    component: YkbReport
  },
  {
    path: '/pdf',
    name: 'PdfTest',
    component: PdfTest
  },
  {
    path: '/NewReport',
    name: 'NewReport',
    component: NewReport
  },
  {
    path: '/NewReportFullView',
    name: 'NewReportFullView',
    component: NewReportFullView
  },
  {
    path: '/GuReport',
    name: 'GuReport',
    component: GuReport,
    meta: {
      title: '骨健康评估'
      },
  },
  {
    path: '/SportsRiskReport',
    name: 'SportsRiskReport',
    component: SportsRiskReport,
    meta: {
      title: '运动风险评估'
      },
  },
  {
    path: '/PeaceMind',
    name: 'PeaceMind',
    component: PeaceMind,
    meta: {
      title: '多维健康评估'
      },
  },
	 {
	  path: '/Physical',
	  name: 'Physical',
	  component: Physical,
	  meta: {
	    title: '体能健康检测'
	    },
	},
  {
    path: '/PeaceMindH5',
    name: 'PeaceMindH5',
    component: PeaceMindH5,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/peaceCondition',
    name: 'condition',
    component: condition,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/peaceSystem',
    name: 'system',
    component: system,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/peaceSystemContent',
    name: 'systemContent',
    component: systemContent,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/PeaceMindH5Old',
    name: 'PeaceMindH5Old',
    component: PeaceMindH5Old,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/peaceConditionOld',
    name: 'conditionOld',
    component: conditionOld,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/peaceSystemOld',
    name: 'systemOld',
    component: systemOld,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/peaceSystemContentOld',
    name: 'systemContentOld',
    component: systemContentOld,
    meta: {
      title: '多维健康评估'
      },
  },
  {
    path: '/HeartBrainReport',
    name: 'HeartBrainReport',
    component: HeartBrainReport
  },
  {
    path: '/thyroid',
    name: 'thyroid',
    component: Thyroid
  },
  {
    path:'/thyroidDetail',
    name: 'ThyroidDetail',
    component: ThyroidDetail
  },
  {
    path: '/riskReport',
    name: 'riskReport',
    component: RiskReport
  },
  {
    path: '/diaeaseReport',
    name: 'DiaeaseReport',
    component: DiaeaseReport
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/keynote',
    name: 'keynote',
    meta: {
      title: '肠胃动力评估'
      },
    component: keynote
  },
  {
    path: '/nutrition',
    name: 'nutrition',
    meta: {
      title: '营养评估'
      },
    component: nutrition
  },
  {
    path: '/contrast',
    name: 'contrast',
    component: contrast,
    meta: {
      title: '肠胃动力评估'
      },
  },
  {
    path: '/noteDetail',
    name: 'noteDetail',
    component: noteDetail,
    meta: {
      title: '肠胃动力评估'
      },
  },
  {
    path: '/reportComparison',
    name: 'reportComparison',
    component: reportComparison,
    meta: {
      title: '肠胃动力评估'
      },
  },
  {
    path: '/FullBodyIntelligence',
    name: 'FullBodyIntelligence',
    component: FullBodyIntelligence,
    meta: {
      title: '全身评估智能版'
      },
  },
   {
    path: '/WholeBodyTriage',
    name: 'WholeBodyTriage',
    component: WholeBodyTriage,
    meta: {
      title: '全身评估智能分诊'
      },
  },
   {
    path: '/YouthSportsLntelligence',
    name: 'YouthSportsLntelligence',
    component: YouthSportsLntelligence,
    meta: {
      title: '青少年运动评估智能版'
      },
  },
]

const router = new VueRouter({
  routes
})

export default router
